import useRememberedState from '../../../hooks/useRememberedState'

export const useSupplierSession = (): [number | null, (supplierId: number | null) => void] => {
  return useRememberedState<number | null>('scan-to-list-books-supplier', true, null)
}
